import { getTFunc } from '@icp/i18n';
import { restApi } from '@icp/settings';

/**
 * 获取当前地理位置，可选逆地理编码。
 * @param {object} options
 * @param {boolean} [options.enableHighAccuracy=true]
 * @param {number} [options.timeout=10000]
 * @param {number} [options.maximumAge=0]
 * @param {string} [options.reverseGeocodeUrl] - 逆地理编码接口地址，POST { latitude, longitude }
 * @param {boolean} [options.suppressGeocodeError=false] - 为 true 时逆地理编码失败不 reject，降级返回经纬度
 * @returns {Promise<{latitude: number, longitude: number, accuracy: number, address: string}>}
 */
export default function getLocation(options = {}) {
  const {
    enableHighAccuracy = true,
    timeout = 10000,
    maximumAge = 0,
    reverseGeocodeUrl,
    suppressGeocodeError = false,
  } = options;
  const t = getTFunc('icp-form-renderer');

  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error(t('location.error-not-supported')));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        const result = { latitude, longitude, accuracy, address: '' };

        if (reverseGeocodeUrl) {
          try {
            const config = { skipResponseInterceptors: true };
            const res = await restApi.post(reverseGeocodeUrl, { latitude, longitude }, config);
            result.address = typeof res === 'string' ? res : res?.address || '';
          } catch (e) {
            if (!suppressGeocodeError) {
              reject(e);
              return;
            }
          }
        }

        resolve(result);
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error(t('location.error-permission-denied')));
            break;
          case error.POSITION_UNAVAILABLE:
            reject(new Error(t('location.error-position-unavailable')));
            break;
          case error.TIMEOUT:
            reject(new Error(t('location.error-timeout')));
            break;
          default:
            reject(new Error(t('location.error-unknown')));
            break;
        }
      },
      { enableHighAccuracy, timeout, maximumAge },
    );
  });
}
